export const createTitleComponent = (level, children, className) => {
  const HX = `h${level}`;
  return <HX className={className}>{children}</HX>;
};
